import { createContext } from 'react';
import type { DealRevenueModifiersState } from './types.ts';

export const DealRevenueModifiersContext = createContext<DealRevenueModifiersState | null>(null);
